import { prophetTypes } from '../types';
import { ChunkPlatform, getChunkUsage } from '../utils/chunk-limits';

const isRequired = (v: string | undefined, name: string) =>
  v ? undefined : `Поле ${name} обязательно`;

const messagesArray = (field: string, messages?: prophetTypes.RuleMessage[][]) => {
  if (!messages || !Array.isArray(messages) || !messages.length) {
    return `Поле ${field} обязательно`;
  }
};

const messages = (
  field: string,
  messagesArray: prophetTypes.RuleMessage[][] = [],
  acceptedTypes: ('text' | 'image')[] = ['image', 'text'],
  // Per-platform chunk limit, in characters (runtime-configurable via
  // GET /config). See utils/chunk-limits.ts for rationale. Optional so
  // legacy callers without platform context fall back to the conservative
  // telegram limit; new callers should always pass it.
  platform: ChunkPlatform = 'telegram'
) => {
  for (const [variantIndex, variant] of messagesArray.entries()) {
    if (!Array.isArray(variant) || !variant.length) {
      return `Пустое поле ${field}`;
    }
    for (const [partIndex, message] of variant.entries()) {
      if (!acceptedTypes.includes(message.type)) {
        return `Неправильный тип сообщения в поле ${field}`;
      }
      if (message.type === 'image' && !('url' in message) && !('file' in message)) {
        return `Не правильное фото в поле ${field}`;
      }
      if (message.type === 'image' && 'file' in message && message.file.size >= 3145728) {
        return `Фото в поле ${field} не должно превышать 3мб`;
      }
      if (message.type === 'text' && !message.text) {
        return `Не правильный текст в поле ${field}`;
      }
      // Platform-aware chunk-size gate. Prophet's send-worker treats each
      // text as one rate-limited Meta send; if the chunk is oversized the
      // instagram/telegram-server splitter would re-cut it (warn-logged
      // fallback) and the rate-limit slot accounting silently misses the
      // extra Meta calls. Editors split long content into additional
      // "Часть" cards via the "Добавить часть" UI.
      if (message.type === 'text' && typeof message.text === 'string') {
        const usage = getChunkUsage(message.text, platform);
        if (usage.exceedsLimit) {
          return `Поле «${field}», вариант ${variantIndex + 1}, часть ${partIndex + 1} превышает ${usage.limit} символов (${usage.current})`;
        }
      }
    }
  }
};

export const validations = { isRequired, messagesArray, messages };
